// Membership errors of the edit listing flow. Kept free of React and component imports,
// because EditListingPage.duck.js uses them and ducks are loaded by the route configuration.

// The seller's membership has no room for another listing (see server/api/stripe/listing-quota.js).
export const LISTING_LIMIT_REACHED_ERROR = 'ListingLimitReachedError';
// The seller has no active subscription or founding membership.
export const MEMBERSHIP_REQUIRED_ERROR = 'MembershipRequiredError';

/**
 * @param {string} name LISTING_LIMIT_REACHED_ERROR or MEMBERSHIP_REQUIRED_ERROR
 * @param {Object} [details] Extra data, e.g. the listing quota
 * @returns {Object} An error in the shape of storableError, so it can be kept in the store
 */
export const membershipError = (name, details = {}) => ({
  type: 'error',
  name,
  message: 'The membership does not allow this listing.',
  status: 403,
  statusText: name,
  ...details,
});

/**
 * @param {Object} error
 * @returns {boolean} Whether the error is about the seller's membership
 */
export const isMembershipError = error =>
  [LISTING_LIMIT_REACHED_ERROR, MEMBERSHIP_REQUIRED_ERROR].includes(error?.name);
